<template>
  <div>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <div>
          <div>
            <div>
              <v-select
                v-for="optOut in internal.updates"
                v-model="optOut.status"
                :key="optOut.optOutId"
                item-value="value"
                item-text="text"
                :items="optOut.items"
                :label="optOut.coverageGroupName"
                class="required"
                @change="onStatusChange"
              />
            </div>
          </div>
        </div>
        <p>Email Message</p>
        <quill-editor v-model="internal.message" />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text @click="$emit('close')" :disabled="saving">
        {{ $t("globals.cancel") }}
      </v-btn>
      <v-btn
        color="primary"
        text
        :loading="saving"
        :disabled="!valid || saving || !hasChanges"
        @click="$emit('save', internal)"
      >
        {{ $t("globals.update") }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    optOuts: Array,
    emailText: String,
    emailTemplates: Array,
    saving: Boolean,
  },
  data() {
    const allStatuses = [
      { value: "Pending", text: "Pending" },
      { value: "Approved", text: "Approved" },
      { value: "Rejected", text: "Rejected" },
      { value: "TentativelyApproved", text: "Tentatively Approved" },

      { text: "Received", value: "Received" },
      { text: "Updated", value: "Updated" },
      { text: "Cancelled", value: "Cancelled" },
      { text: "Paid", value: "Paid" },
    ];
    return {
      valid: false,
      internal: {
        updates: [],
        message: "",
      },
      initialStatuses: {},
      statuses: [...allStatuses],
      allStatuses: [...allStatuses],
    };
  },
  computed: {
    hasChanges() {
      if (!this.internal.updates || this.internal.updates.length === 0) {
        return false;
      }
      return this.internal.updates.some(update => {
        const initialStatus = this.initialStatuses[update.optOutId];
        return update.status !== initialStatus;
      });
    }
  },
  methods: {
    ...mapActions("optouts", ["optOutCanBeApproved"]),

    async checkIfOptOutCanBeApproved(optOutId, currentStatus) {
      const canBeApproved = await this.optOutCanBeApproved(optOutId);
      const excludedStatuses = ["Received", "Updated", "Cancelled", "Paid"];

      let available = this.statuses.filter(s => 
        !excludedStatuses.includes(s.value)
      );
      
      if (!canBeApproved) {
        available = available.filter(s => s.value !== "Approved");
      } else {
        available = available.filter(s => s.value !== "TentativelyApproved");
      }

      if (excludedStatuses.includes(currentStatus)) {
        const currentStatusItem = this.statuses.find(s => s.value === currentStatus);
        if (currentStatusItem) {
          available = [
            {...currentStatusItem, disabled: true },
            ...available
          ];
        }
      }
      
      return available;
    },

    async onStatusChange() {
      const currentStatuses = this.internal.updates
        .filter((x) => String(x.status).length > 0)
        .map((x) => x.status);

      if (currentStatuses.length == 0) {
        return;
      }

      let status = currentStatuses[0];

      for (let i = 0; i < currentStatuses.length; i++) {
        if (currentStatuses[i] !== status) {
          status = "Updated";
          break;
        }
      }

      const selectedTemplate = this.emailTemplates.find(
        (t) => t.emailStatus === status
      );

      this.internal.message = selectedTemplate.template;
    },
  },
  watch: {
    optOuts: {
      immediate: true,
      async handler(v) {
        if (v) {
          this.internal.updates = [];
          this.initialStatuses = {};

          for (var optOut of this.optOuts) {
            const sortedStatuses = [...(optOut.Statuses || [])].sort((a, b) =>
              new Date(a.EffectiveDate) - new Date(b.EffectiveDate)
            );
            const currentStatus = sortedStatuses.length
              ? sortedStatuses[sortedStatuses.length - 1].Status
              : "";

            this.initialStatuses[optOut.Id] = currentStatus;
            const available = await this.checkIfOptOutCanBeApproved(optOut.Id,currentStatus);
            this.internal.updates.push({
              optOutId: optOut.Id,
              status: currentStatus,
              items: available,
              coverageGroupName: optOut.CoverageGroup?.Name,
            });
          }
        }
      },
    },
  },
};
</script>
